import React from 'react';
import { Container, Box, Typography, AppBar, Toolbar, IconButton } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const TermsOfServicePage = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/');
    };

    return (
        <Box>
            {/* Header */}
            <AppBar
                position="sticky"
                sx={{
                    bgcolor: 'rgba(255, 255, 255, 0.9)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
                }}
            >
                <Toolbar>
                    <IconButton onClick={handleBack} sx={{ color: 'primary.main', mr: 2 }}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                        <img
                            src="/logo-192x192.png"
                            alt="Find solution Logo"
                            style={{ height: '32px', width: '32px', marginRight: '12px' }}
                        />
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 'bold',
                                color: 'primary.main'
                            }}
                        >
                            Find solution
                        </Typography>
                    </Box>
                </Toolbar>
            </AppBar>

            {/* Content */}
            <Container maxWidth="md" sx={{ py: 6 }}>
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 'bold',
                        color: 'grey.800',
                        mb: 4,
                        textAlign: 'center'
                    }}
                >
                    Regulamin
                </Typography>

                <Box sx={{ '& > *': { mb: 3 } }}>
                    <Typography variant="body1" sx={{ color: 'grey.600', mb: 4, textAlign: 'center' }}>
                        Ostatnia aktualizacja: {new Date().toLocaleDateString('pl-PL')}
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        1. Postanowienia ogólne
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Niniejszy Regulamin określa zasady korzystania z aplikacji Find solution, świadczącej usługi psychologicznego wsparcia z wykorzystaniem sztucznej inteligencji. Korzystając z aplikacji, akceptujesz wszystkie postanowienia niniejszego Regulaminu.
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        2. Definicje
                    </Typography>
                    <Box component="ul" sx={{ color: 'grey.700', lineHeight: 1.6, pl: 3 }}>
                        <li><strong>Aplikacja</strong> - aplikacja internetowa Find solution</li>
                        <li><strong>Usługodawca</strong> - [Nazwa firmy] świadczący usługi za pośrednictwem Aplikacji</li>
                        <li><strong>Użytkownik</strong> - osoba korzystająca z Aplikacji</li>
                        <li><strong>Pakiet Mocy</strong> - spersonalizowany plan działania generowany przez Aplikację</li>
                    </Box>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        3. Opis usług
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Find solution oferuje:
                    </Typography>
                    <Box component="ul" sx={{ color: 'grey.700', lineHeight: 1.6, pl: 3 }}>
                        <li>Ankietę psychologiczną opartą na sztucznej inteligencji</li>
                        <li>Generowanie spersonalizowanych planów działania (Pakiet Mocy)</li>
                        <li>Wsparcie w rozwiązywaniu problemów związanych z pracą, relacjami i stresem</li>
                        <li>Dostęp do materiałów edukacyjnych i strategii radzenia sobie</li>
                    </Box>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        4. Warunki korzystania
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Aby korzystać z Aplikacji, Użytkownik musi:
                    </Typography>
                    <Box component="ul" sx={{ color: 'grey.700', lineHeight: 1.6, pl: 3 }}>
                        <li>Mieć ukończone 18 lat</li>
                        <li>Akceptować niniejszy Regulamin</li>
                        <li>Wyrażać zgodę na przetwarzanie danych osobowych</li>
                        <li>Korzystać z Aplikacji zgodnie z jej przeznaczeniem</li>
                    </Box>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        5. Ograniczenia i zastrzeżenia
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6, mb: 2 }}>
                        <strong>WAŻNE:</strong> Find solution nie zastępuje profesjonalnej terapii psychologicznej ani psychiatrycznej. Aplikacja służy jako narzędzie wsparcia i samopomocy.
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Użytkownik nie może:
                    </Typography>
                    <Box component="ul" sx={{ color: 'grey.700', lineHeight: 1.6, pl: 3 }}>
                        <li>Używać Aplikacji w sposób niezgodny z prawem</li>
                        <li>Próbować uzyskać nieautoryzowanego dostępu do systemów</li>
                        <li>Udostępniać konta innym osobom</li>
                        <li>Wprowadzać fałszywych informacji</li>
                        <li>Używać Aplikacji w celach komercyjnych bez zgody</li>
                    </Box>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        6. Płatności i rozliczenia
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Niektóre funkcje Aplikacji mogą być płatne. Ceny są podane w złotych polskich i zawierają podatek VAT. Płatności są przetwarzane przez bezpieczne systemy płatności. Użytkownik ma prawo do odstąpienia od umowy w terminie 14 dni.
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        7. Odpowiedzialność
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Usługodawca dołoży wszelkich starań, aby Aplikacja działała prawidłowo, jednak nie gwarantuje:
                    </Typography>
                    <Box component="ul" sx={{ color: 'grey.700', lineHeight: 1.6, pl: 3 }}>
                        <li>Nieprzerwanego działania Aplikacji</li>
                        <li>Braku błędów technicznych</li>
                        <li>Konkretnych rezultatów terapeutycznych</li>
                    </Box>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Użytkownik korzysta z Aplikacji na własną odpowiedzialność.
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        8. Sytuacje kryzysowe
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6, mb: 2 }}>
                        <strong>W przypadku myśli samobójczych lub kryzysu psychicznego, natychmiast skontaktuj się z:</strong>
                    </Typography>
                    <Box component="ul" sx={{ color: 'grey.700', lineHeight: 1.6, pl: 3 }}>
                        <li>Numerem alarmowym: 112</li>
                        <li>Telefonem Zaufania: 116 123</li>
                        <li>Najbliższym szpitalem psychiatrycznym</li>
                    </Box>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        9. Własność intelektualna
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Wszystkie treści, algorytmy i elementy Aplikacji są chronione prawem autorskim. Użytkownik może korzystać z wygenerowanych dla niego materiałów wyłącznie do celów osobistych.
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        10. Rozwiązywanie sporów
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        W przypadku sporów, strony będą dążyć do polubownego rozwiązania. Właściwym prawem jest prawo polskie, a właściwym sądem - sąd właściwy dla siedziby Usługodawcy.
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        11. Zmiany regulaminu
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        Usługodawca zastrzega sobie prawo do wprowadzania zmian w Regulaminie. O zmianach Użytkownicy będą informowani z 7-dniowym wyprzedzeniem.
                    </Typography>

                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'grey.800', mt: 4, mb: 2 }}>
                        12. Kontakt
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'grey.700', lineHeight: 1.6 }}>
                        W sprawach dotyczących Regulaminu można skontaktować się pod adresem: [email kontaktowy]
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default TermsOfServicePage;

